<script>
  import { Router } from "svelte-navigator";
  import RaceCard from "./RaceCard.svelte";
  //import { onMount } from "svelte";
  import { selectedRaceId, races } from '../stores';
  /*
  onMount(() => {
    $uniqueRiderList = new Map;
    const allRiderData = JSON.parse(JSON.stringify($data));
    
    allRiderData.forEach((el) => {
		  $uniqueRiderList.set(el.pn, el);
	  });
  });

  */
  function onRaceButtonClick(race_id) {
    selectedRaceId.set(race_id);
  }

  //$: $allData = JSON.parse(JSON.stringify($data));
  
  const raceArray = JSON.parse(JSON.stringify($races));
  raceArray.sort((x,y) => {
    return y.id - x.id;
  });
</script>

<section>
<!--<section in:fade="{{delay: 250, duration: 300}}" out:fade="{{delay: 10, duration: 100}}">-->
  <div class="container m-0">
    <div class="row">
      <Router>
        {#each raceArray as {id, name, date, completed, location, color, bg_color}}
          <RaceCard
            id={id}
            name={name}
            date={date}
            completed={completed}
            location={location}
            color={color}
          />
        {/each}
      </Router>
    </div>
  </div>
</section>


<style>
  section {
    width: 100%;
  }
</style>